import { post } from "@/utils/utils";

const decoration = {
  state: {
    indexTemp: [],
    tempDetails: {},
    storeStyle: {},
    microShopRouteList: [],
    goodsTempRow: {},
    actTempRow: {}
  },
  mutations: {
    EDIT_GOODS_SHARE_TEMP() {},
    ADD_TEMP() {},
    ADD_GOODS_SHARE_TEMP() {},
    REMOVE_GOODS_SHARE_TEMP() {},
    QUERY_GOODS_SHARE_TEMP_LIST() {},
    DELETE_TEMP() {},
    QUERY_INDEX_TEMP(state, data) {
      state.indexTemp = data.result;
    },
    QUERY_TEMP_DETAILS(state, data) {
      state.tempDetails = data.result;
    },
    ADD_CUSTOM_TEMP() {},
    EDIT_CUSTOM_TEMP() {},
    QUERY_STORE_STYLE(state, data) {
      state.storeStyle = data.result;
    },
    QUERY_MICRO_PAGE_COUNT() {},
    SET_STORE_STYLE() {},
    QUERY_GROUP_GOODS() {},
    QUERY_DAILY_DEALS() {},
    QUERY_DAILY_NEWS() {},
    QUERY_GROUP_GOODS_WATERMARK() {},
    QUERY_LAYOUT_LIST(state, data) {
      const list = data.result.sort((a, b) => {
        return a.hrefName.localeCompare(b.hrefName, "zh");
      });
      state.microShopRouteList = list.filter(
        v => v.hrefAddress !== "/pages/coupon/plusCoupon"
      );
    },
    SET_GOODS_TEMP_ROW(state, data) {
      state.goodsTempRow = data;
    },
    SET_ACT_TEMP_ROW(state, data) {
      state.actTempRow = data;
    },
    QUERY_STORE_GOODS_SHARE_TEMP_LIST() {},
    SHOP_USE_TEMP() {},
    SHOP_CHANGE_TEMP() {},
    QUERY_IS_SHOW_CONSUME_RANK_COMPONENT() {},
    QUERY_HELPING_RECORD_LIST() {},
    QUERY_HELPING_DEATIL_RECORD_LIST() {},
    HOT_MAP() {},
    DATE_CONT() {},
    CHOOSE_PRODUCTN_FORMATION() {},
    IMPORT_GOODS() {},
    PRODUCT_LINE_LIST() {},
    ADD_GOODS_LINE() {},
    ADIT_GOODS_LINE() {},
    AUTH_STORE_LIST() {},
    STORE_SELECTION_SPU_INFO_PAGE_LIST() {},
    STORE_SELECTION_SPUTHIRD_ADD() {},
    MY_PAGE_THIRD_LIST() {},
    SHARE_STORE_LIST() {},
    DISTRIBUTION_LIST() {},
    FIND_THIRD_EXPRESS_ORDER_PAGE() {},
    AUTH_SHARE_STORE_LIST() {},
    AUTH_TAG_LIST() {},
    AUTH_TAG_ADD() {},
    AUTH_STORE_EDIT() {},
    SKU_INFO() {},
    EDIT_SKU_INFO() {},
    ADD_STOCK() {},
    BATCH_EDIT() {},
    STORE_SELECTION_ORDER_DETAIL() {},
    SELECTION_ORDER_DETAIL() {},
    ALL_SUPPLIER_LIST() {},
    ALL_SHARE_STORE_LIST() {},
    QUERY_MEMBER_SAVE_MONEY_CARD_INFO_LIST() {},
    QUERY_SAVE_MONEY_CARD_RULE_LIST() {},
    QUERY_PASSWORD_JOIN_LIST() {},
    FROZEN_MEMBER_SAVE_MONEY_CARD() {},
    QUERY_STORE_HOT_SALE_GAME_GOODS_LIST() {},
    HEAT_MAP_AREA() {},
    QUERY_ATTR_L2LIST() {},
    QUERY_ATTR_L3LIST() {},
    SYS_DICTIONARY_TYPE_INFO_ADD() {},
    SYS_DICTIONARY_TYPE_INFO_QUERY_PAGE_LIST() {},
    SYS_DICTIONARY_TYPE_INFO_REMOVE_BY_MODEL() {},
    SYS_DICTIONARY_GROUP_INFO_QUERY_PAGE_LIST() {},
    SYS_DICTIONARY_GROUP_INFO_ADD() {},
    SYS_DICTIONARY_GROUP_INFO_EDIT() {},
    SYS_DICTIONARY_GROUP_INFO_QUERY_BY_ID() {},
    SYS_DICTIONARY_GROUP_INFO_REMOVE_BY_MODEL() {},
    SYS_DICTIONARY_WORD_INFO_ADD() {},
    SYS_DICTIONARY_WORD_INFO_EDIT() {},
    SYS_DICTIONARY_WORD_INFO_REMOVE_BY_MODEL() {},
    SYS_DICTIONARY_WORD_INFO_QUERY_PAGE_LIST() {},
    STORE_DICTIONARY_RULE_INFO_QUERY_PAGE_LIST() {},
    STORE_DICTIONARY_RULE_INFO_REMOVE_BY_MODEL() {},
    STORE_DICTIONARY_RULE_INFO_ADD() {},
    STORE_DICTIONARY_RULE_INFO_EDIT() {},
    STORE_DICTIONARY_RULE_INFO_QUERY_BY_ID() {},
    STORE_DICTIONARY_RULE_GROUP_REL_QUERY_PAGE_LIST() {},
    STORE_DICTIONARY_RULE_GROUP_REL_ADD() {},
    STORE_DICTIONARY_RULE_GROUP_REL_REMOVE_BY_MODEL() {},
    STORE_DICTIONARY_WORD_INFO_ADD() {},
    STORE_DICTIONARY_WORD_INFO_QUERY_PAGE_LIST() {},
    STORE_DICTIONARY_WORD_INFO_REMOVE_BY_MODEL() {},
    STORE_DICTIONARY_RULE_ATTR_REL_QUERY_PAGE_LIST() {},
    STORE_DICTIONARY_RULE_ATTR_REL_ADD() {},
    STORE_DICTIONARY_RULE_ATTR_REL_REMOVE_BY_MODEL() {},
    HELP_COUPON_EXPORT(){},
    STORE_REGION_QUERY_PAGE_LIST(){},
    STORE_REGION_ADD(){},
    STORE_REGION_EDIT(){},
    STORE_REGION_UPDATE_STATUS(){}
  },
  actions: {
    shopChangeTempConfirm({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/shop_change_model_confirm`,
        name: "SHOP_CHANGE_TEMP",
        params
      });
    },
    shopUseTemp({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/shop_use_model`,
        name: "SHOP_USE_TEMP",
        params
      });
    },
    addGoodShareTemp({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/share_page/add`,
        name: "ADD_GOODS_SHARE_TEMP",
        params
      });
    },
    editGoodShareTemp({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/share_page/edit`,
        name: "EDIT_GOODS_SHARE_TEMP",
        params
      });
    },
    queryGoodShareTempList({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/share_page/list`,
        name: "QUERY_GOODS_SHARE_TEMP_LIST",
        params
      });
    },
    queryStoreGoodShareTempList({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/shop_preview_index`,
        name: "QUERY_STORE_GOODS_SHARE_TEMP_LIST",
        params
      });
    },
    removeGoodShareTemp({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/query`,
        name: "REMOVE_GOODS_SHARE_TEMP",
        params
      });
    },
    queryMicroPageCount({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/query`,
        name: "QUERY_MICRO_PAGE_COUNT",
        params
      });
    },
    queryGroupGoodsWatermark({ commit }, params) {
      return post({
        commit,
        url: `/mobile_mall/spu_group_info`,
        name: "QUERY_GROUP_GOODS",
        params
      });
    },
    queryGroupGoods({ commit }, params) {
      return post({
        commit,
        url: `/mobile_mall/spu_list`,
        name: "QUERY_GROUP_GOODS",
        params
      });
    },
    queryDailyDeals({ commit }, params) {
      return post({
        commit,
        url: `/mobile_mall/goods_daily_deals`, 
        name: "QUERY_DAILY_DEALS",
        params
      });
    },
    queryDailyNews({ commit }, params) {
      return post({
        commit,
        url: `/mobile_mall/goods_daily_news`, 
        name: "QUERY_DAILY_NEWS",
        params
      });
    },
    queryMicroShopList({ commit }, params) {
      return post({
        commit,
        url: `/sys/layout_href/list`,
        name: "QUERY_LAYOUT_LIST",
        params
      });
    },
    queryStoreStyle({ commit }, params) {
      return post({
        commit,
        url: `/basic/style/detail`,
        name: "QUERY_STORE_STYLE",
        params
      });
    },
    setStoreStyle({ commit }, params) {
      return post({
        commit,
        url: `/basic/style/edit`,
        name: "SET_STORE_STYLE",
        params
      });
    },
    addTemp({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/default/add_edit`,
        name: "ADD_TEMP",
        params
      });
    },
    deleteTemp({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/customize/del`,
        name: "DELETE_TEMP",
        params
      });
    },
    editTemp({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/customize/edit`,
        name: "EDIT_CUSTOM_TEMP",
        params
      });
    },
    addCustomTemp({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/customize/add`,
        name: "ADD_CUSTOM_TEMP",
        params
      });
    },
    queryIndexTemp({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/preview_index`,
        name: "QUERY_INDEX_TEMP",
        params
      });
    },
    queryTempDetails({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/detail`,
        name: "QUERY_TEMP_DETAILS",
        params
      });
    },
    queryIsShowConsumeRankComponent({ commit }, params) {
      return post({
        commit,
        url: `/store/storeErpSyncFuncAuthRel/checkStoreAuthCode`,
        name: "QUERY_IS_SHOW_CONSUME_RANK_COMPONENT",
        params
      });
    },
    queryHelpingRecordList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryHelpCouponLaunchRecordList`,
        name: "QUERY_HELPING_RECORD_LIST",
        params
      });
    },
    hotmap({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/page_heat_map`,
        name: "HOT_MAP",
        params
      });
    },
    dateCont({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout/page_heat_map/static`,
        name: "DATE_CONT",
        params
      });
    },
    queryHelpingDeatilRecordList({ commit }, params) {
      return post({
        commit,
        url: `/game/queryHelpCouponHelpRecordList`,
        name: "QUERY_HELPING_DEATIL_RECORD_LIST",
        params
      });
    },
    ChooseProductnFormation({ commit }, params) {  //选品信息查询
      return post({
        commit,
        url: `/store/storeSelectionSpuInfo/page_list`,
        name: "CHOOSE_PRODUCTN_FORMATION",
        params
      });
    },
    importGoodsSelection({ commit }, params) {  //选品信息导入
      return post({
        commit,
        url: `/store/storeSelectionSpuInfo/import`,
        name: "IMPORT_GOODS",
        params
      });
    },
    ProductLineList({ commit }, params){   //产品线列表查询
      return post({
        commit,
        url: `/store/storeSelectionSpuInfo/goods_line_list`,
        name: "PRODUCT_LINE_LIST",
        params
      });
    },
    add_goods_line({ commit }, params){   //新增产品线
      return post({
        commit,
        url: `/store/storeSelectionSpuInfo/add_goods_line`,
        name: "ADD_GOODS_LINE",
        params
      });
    },
    adit_goods_line({ commit }, params){   //修改产品线
      return post({
        commit,
        url: `/store/storeSelectionSpuInfo/edit`,
        name: "ADIT_GOODS_LINE",
        params
      });
    },
    auth_store_list({ commit }, params){   //查询供货商
      return post({
        commit,
        url: `/store/storeSelectionAuthInfo/auth_store_list`,
        name: "AUTH_STORE_LIST",
        params
      });
    },
    store_Selection_Spu_Info_Page_list({ commit }, params){   //查询供货选品列表
      return post({
        commit,
        url: `/store/storeSelectionSpuInfo/page_list`,
        name: "STORE_SELECTION_SPU_INFO_PAGE_LIST",
        params
      });
    },
    storeSelectionSpuThirdAdd({ commit }, params){   //查询供货选品列表
      return post({
        commit,
        url: `/store/storeSelectionSpuThird/add`,
        name: "STORE_SELECTION_SPUTHIRD_ADD",
        params
      });
    },
    my_page_third_list({ commit }, params){   //我的选品列表查询
      return post({
        commit,
        url: `/store/storeSelectionSpuThird/page_third_list`,
        name: "MY_PAGE_THIRD_LIST",
        params
      });
    },
    share_store_list({ commit }, params){   //分销商列表查询
      return post({
        commit,
        url: `/store/storeSelectionAuthInfo/share_store_list`,
        name: "SHARE_STORE_LIST",
        params
      });
    },
    distribution_list({ commit }, params){   //分销商铺货明细查询
      return post({
        commit,
        url: `/store/storeSelectionSpuThird/distribution_list`,
        name: "DISTRIBUTION_LIST",
        params
      });
    },
    findThirdExpressOrderPage({ commit }, params){   //代销发货查询
      return post({
        commit,
        url: `/order/findThirdExpressOrderPage`,
        name: "FIND_THIRD_EXPRESS_ORDER_PAGE",
        params
      });
    },
    auth_share_store_list({ commit }, params){   //查询分销商列表
      return post({
        commit,
        url: `/store/storeSelectionAuthInfo/auth_share_store_list`,
        name: "AUTH_SHARE_STORE_LIST",
        params
      });
    },
    auth_tag_list({ commit }, params){   //查询分销商分组列表
      return post({
        commit,
        url: `/store/storeSelectionAuthInfo/auth_tag_list`,
        name: "AUTH_TAG_LIST",
        params
      });
    },
    auth_tag_add({ commit }, params){   //新增分销商分组
      return post({
        commit,
        url: `/store/storeSelectionAuthInfo/auth_tag_add`,
        name: "AUTH_TAG_ADD",
        params
      });
    },
    auth_store_edit({ commit }, params){   //编辑分销商分组
      return post({
        commit,
        url: `/store/storeSelectionAuthInfo/auth_store_edit`,
        name: "AUTH_STORE_EDIT",
        params
      });
    },
    sku_info({ commit }, params){   //选品规格查询
      return post({
        commit,
        url: `/store/storeSelectionSpuInfo/sku_info`,
        name: "SKU_INFO",
        params
      });
    },
    edit_sku_info({ commit }, params){   //选品价格管理修改
      return post({
        commit,
        url: `/store/storeSelectionSpuInfo/edit_sku_info`,
        name: "EDIT_SKU_INFO",
        params
      });
    },
    add_stock({ commit }, params){   //增加库存
      return post({
        commit,
        url: `/store/storeSelectionSpuThird/add_stock`,
        name: "ADD_STOCK",
        params
      });
    },
    batch_edit({ commit }, params){   //批量停售
      return post({
        commit,
        url: `/store/storeSelectionSpuInfo/batch_edit`,
        name: "BATCH_EDIT",
        params
      });
    },
    storeSelectionOrderDetail({ commit }, params){   //选品分销纪录列表查询
      return post({
        commit,
        url: `/store/storeSelectionOrderDetail/queryPageList`,
        name: "STORE_SELECTION_ORDER_DETAIL",
        params
      });
    },
    SelectionOrderDetail({ commit }, params){   //订单详情查询
      return post({
        commit,
        url: `/store/storeSelectionOrderDetail/detail`,
        name: "SELECTION_ORDER_DETAIL",
        params
      });
    },
    all_supplier_list({ commit }, params){   //总供应商列表
      return post({
        commit,
        url: `/store/storeSelectionAuthInfo/all_supplier_list`,
        name: "ALL_SUPPLIER_LIST",
        params
      });
    },
    all_share_store_list({ commit }, params){   //总分销商列表
      return post({
        commit,
        url: `/store/storeSelectionAuthInfo/all_share_store_list`,
        name: "ALL_SHARE_STORE_LIST",
        params
      });
    },
    queryMemberSaveMoneyCardInfoList({ commit }, params){   //总分销商列表
      return post({
        commit,
        url: `/game/queryMemberSaveMoneyCardInfoList`,
        name: "QUERY_MEMBER_SAVE_MONEY_CARD_INFO_LIST",
        params
      });
    },
    querySaveMoneyCardRuleList({ commit }, params){   //总分销商列表
      return post({
        commit,
        url: `/game/querySaveMoneyCardRuleList`,
        name: "QUERY_SAVE_MONEY_CARD_RULE_LIST",
        params
      });
    },
    queryPasswordJoinList({ commit }, params){   //口令红包详情列表
      return post({
        commit,
        url: `/game/queryPasswordJoinList`,
        name: "QUERY_PASSWORD_JOIN_LIST",
        params
      });
    },
    frozenMemberSaveMoneyCard({ commit }, params){   //冻结省钱卡
      return post({
        commit,
        url: `/game/frozenMemberSaveMoneyCard`,
        name: "FROZEN_MEMBER_SAVE_MONEY_CARD",
        params
      });
    },
    queryStoreHotSaleGameGoodsList({ commit }, params){   
      return post({
        commit,
        url: `/game/small/queryStoreHotSaleGameGoodsList`,
        name: "QUERY_STORE_HOT_SALE_GAME_GOODS_LIST",
        params
      });
    },
    heatMapArea({ commit }, params) {
      return post({
        commit,
        url: `/basic/layout//heat_map_area/static`,
        name: "HEAT_MAP_AREA",
        params
      });
    },
    queryAttrL2List({ commit }, params) {
      return post({
        commit,
        url: `/basic/attribute/queryAttrL2List`,
        name: "QUERY_ATTR_L2LIST",
        params
      });
    },
    queryAttrL3List({ commit }, params) {
      return post({
        commit,
        url: `/basic/attribute/queryAttrL3List`,
        name: "QUERY_ATTR_L3LIST",
        params
      });
    },
    sysDictionaryTypeInfoAdd({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/sysDictionaryTypeInfo/add`,
        name: "SYS_DICTIONARY_TYPE_INFO_ADD",
        params
      });
    },
    sysDictionaryTypeInfoQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/sysDictionaryTypeInfo/queryPageList`,
        name: "SYS_DICTIONARY_TYPE_INFO_QUERY_PAGE_LIST",
        params
      });
    },
    sysDictionaryTypeInfoRemoveByModel({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/sysDictionaryTypeInfo/removeByModel`,
        name: "SYS_DICTIONARY_TYPE_INFO_REMOVE_BY_MODEL",
        params
      });
    },
    sysDictionaryGroupInfoQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/sysDictionaryGroupInfo/queryPageList`,
        name: "SYS_DICTIONARY_GROUP_INFO_QUERY_PAGE_LIST",
        params
      });
    },
    sysDictionaryGroupInfoAdd({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/sysDictionaryGroupInfo/add`,
        name: "SYS_DICTIONARY_GROUP_INFO_ADD",
        params
      });
    },
    sysDictionaryGroupInfoEdit({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/sysDictionaryGroupInfo/edit`,
        name: "SYS_DICTIONARY_GROUP_INFO_EDIT",
        params
      });
    },
    sysDictionaryGroupInfoQueryById({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/sysDictionaryGroupInfo/queryById`,
        name: "SYS_DICTIONARY_GROUP_INFO_QUERY_BY_ID",
        params
      });
    },
    sysDictionaryGroupInfoRemoveByModel({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/sysDictionaryGroupInfo/removeByModel`,
        name: "SYS_DICTIONARY_GROUP_INFO_REMOVE_BY_MODEL",
        params
      });
    },
    sysDictionaryWordInfoAdd({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/sysDictionaryWordInfo/add`,
        name: "SYS_DICTIONARY_WORD_INFO_ADD",
        params
      });
    },
    sysDictionaryWordInfoEdit({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/sysDictionaryWordInfo/edit`,
        name: "SYS_DICTIONARY_WORD_INFO_EDIT",
        params
      });
    },
    sysDictionaryWordInfoRemoveByModel({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/sysDictionaryWordInfo/removeByModel`,
        name: "SYS_DICTIONARY_WORD_INFO_REMOVE_BY_MODEL",
        params
      });
    },   
    sysDictionaryWordInfoQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/sysDictionaryWordInfo/queryPageList`,
        name: "SYS_DICTIONARY_WORD_INFO_QUERY_PAGE_LIST",
        params
      });
    },
    storeDictionaryRuleInfoQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/storeDictionaryRuleInfo/queryPageList`,
        name: "STORE_DICTIONARY_RULE_INFO_QUERY_PAGE_LIST",
        params
      });
    },    
    storeDictionaryRuleInfoRemoveByModel({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/storeDictionaryRuleInfo/removeByModel`,
        name: "STORE_DICTIONARY_RULE_INFO_REMOVE_BY_MODEL",
        params
      });
    },
    storeDictionaryRuleInfoAdd({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/storeDictionaryRuleInfo/add`,
        name: "STORE_DICTIONARY_RULE_INFO_ADD",
        params
      });
    },
    storeDictionaryRuleInfoEdit({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/storeDictionaryRuleInfo/edit`,
        name: "STORE_DICTIONARY_RULE_INFO_EDIT",
        params
      });
    },
    storeDictionaryRuleInfoQueryById({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/storeDictionaryRuleInfo/queryById`,
        name: "STORE_DICTIONARY_RULE_INFO_QUERY_BY_ID",
        params
      });
    },
    storeDictionaryRuleGroupRelQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/storeDictionaryRuleGroupRel/queryPageList`,
        name: "STORE_DICTIONARY_RULE_GROUP_REL_QUERY_PAGE_LIST",
        params
      });
    },
    storeDictionaryRuleGroupRelAdd({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/storeDictionaryRuleGroupRel/add`,
        name: "STORE_DICTIONARY_RULE_GROUP_REL_ADD",
        params
      });
    },
    storeDictionaryRuleGroupRelRemoveByModel({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/storeDictionaryRuleGroupRel/removeByModel`,
        name: "STORE_DICTIONARY_RULE_GROUP_REL_REMOVE_BY_MODEL",
        params
      });
    },
    storeDictionaryWordInfoAdd({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/storeDictionaryWordInfo/add`,
        name: "STORE_DICTIONARY_WORD_INFO_ADD",
        params
      });
    },
    storeDictionaryWordInfoQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/storeDictionaryWordInfo/queryPageList`,
        name: "STORE_DICTIONARY_WORD_INFO_QUERY_PAGE_LIST",
        params
      });
    },
    storeDictionaryWordInfoRemoveByModel({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/storeDictionaryWordInfo/removeByModel`,
        name: "STORE_DICTIONARY_WORD_INFO_REMOVE_BY_MODEL",
        params
      });
    },
    storeDictionaryRuleAttrRelQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/storeDictionaryRuleAttrRel/queryPageList`,
        name: "STORE_DICTIONARY_RULE_ATTR_REL_QUERY_PAGE_LIST",
        params
      });
    },
    storeDictionaryRuleAttrRelAdd({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/storeDictionaryRuleAttrRel/add`,
        name: "STORE_DICTIONARY_RULE_ATTR_REL_ADD",
        params
      });
    },
    storeDictionaryRuleAttrRelRemoveByModel({ commit }, params) {
      return post({
        commit,
        url: `/goods/search/storeDictionaryRuleAttrRel/removeByModel`,
        name: "STORE_DICTIONARY_RULE_ATTR_REL_REMOVE_BY_MODEL",
        params
      });
    },
    // 助力券明细导出
    helpCouponExport({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/game/exportHelpCouponLaunchRecordList`,
        name: "HELP_COUPON_EXPORT",
        params
      });
    },
     // 分区列表管理
     storeRegionQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/region/storeRegion/queryPageList`,
        name: "STORE_REGION_QUERY_PAGE_LIST",
        params
      });
    },
     // 分区列表管理 新增
    storeRegionAdd({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/region/storeRegion/add`,
        name: "STORE_REGION_ADD",
        params
      });
    },
    // 分区列表管理 编辑
    storeRegionEdit({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/region/storeRegion/edit`,
        name: "STORE_REGION_EDIT",
        params
      });
    },
    // 分区列表管理 启用/禁用
    storeRegionUpdateStatus({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/region/storeRegion/updateStatus`,
        name: "STORE_REGION_UPDATE_STATUS",
        params
      });
    },
  }
};

export default decoration;
